"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _EDSContext = require("../EDSContext/EDSContext");
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _tokens = require("@ellucian/react-design-system/core/styles/tokens");
var _styles = require("@ellucian/react-design-system/core/styles");
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
var _Fade = _interopRequireDefault(require("@mui/material/Fade"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _excluded = ["arrow", "children", "classes", "edsContext", "className", "modifiers", "PaperProps", "text", "title", "TextTypographyProps", "TitleTypographyProps", "onClickAway", "ClickAwayListenerProps", "transitionProps", "DrawerProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  var _popperTitle;
  return {
    paperRoot: {
      padding: _tokens.spacing40,
      border: _tokens.borderWidthThin + " solid " + _tokens.colorGlobalBorderDefault,
      borderRadius: _tokens.borderRadiusMedium
    },
    popper: {
      zIndex: theme.zIndex.tooltip,
      // Arrow styling:
      // https://github.com/twbs/bootstrap/blob/master/dist/css/bootstrap.css#L5655
      '& .hedtech-popper-arrow': {
        position: 'absolute',
        display: 'block',
        width: '1rem',
        height: '0.5rem',
        '&::before, &::after': {
          position: 'absolute',
          display: 'block',
          content: '""',
          borderColor: 'transparent',
          borderStyle: 'solid'
        }
      },
      '&[data-popper-placement*="top"] .hedtech-popper-arrow': {
        bottom: '-.5rem',
        '&::before': {
          bottom: 0,
          borderWidth: '0.5rem 0.5rem 0',
          borderTopColor: _tokens.colorGlobalBorderDefault
        },
        '&::after': {
          bottom: 1,
          borderWidth: '0.5rem 0.5rem 0',
          borderTopColor: theme.palette.grey[100]
        }
      },
      '&[data-popper-placement*="right"] .hedtech-popper-arrow': {
        flip: false,
        left: '-.5rem',
        width: '0.5rem',
        height: '1rem',
        '&::before': {
          flip: false,
          left: 0,
          borderWidth: '0.5rem 0.5rem 0.5rem 0',
          borderRightColor: _tokens.colorGlobalBorderDefault
        },
        '&::after': {
          flip: false,
          left: 1,
          borderWidth: '0.5rem 0.5rem 0.5rem 0',
          borderRightColor: theme.palette.grey[100]
        }
      },
      '&[data-popper-placement*="bottom"] .hedtech-popper-arrow': {
        top: '-.5rem',
        '&::before': {
          top: 0,
          borderWidth: '0 0.5rem 0.5rem 0.5rem',
          borderBottomColor: _tokens.colorGlobalBorderDefault
        },
        '&::after': {
          top: 1,
          borderWidth: '0 0.5rem 0.5rem 0.5rem',
          borderBottomColor: theme.palette.grey[100]
        }
      },
      '&[data-popper-placement*="left"] .hedtech-popper-arrow': {
        flip: false,
        right: '-.5rem',
        width: '0.5rem',
        height: '1rem',
        '&::before': {
          flip: false,
          right: 0,
          borderWidth: '0.5rem 0 0.5rem 0.5rem',
          borderLeftColor: _tokens.colorGlobalBorderDefault
        },
        '&::after': {
          flip: false,
          right: 1,
          borderWidth: '0.5rem 0 0.5rem 0.5rem',
          borderLeftColor: theme.palette.grey[100]
        }
      }
    },
    popperText: {
      marginBottom: _tokens.spacing40
    },
    popperTitle: (_popperTitle = {
      // h2 styles
      fontFamily: _tokens.fontFamilyHeader,
      fontWeight: _tokens.fontWeightNormal,
      fontSize: _tokens.fontSizeHeader2Small,
      lineHeight: _tokens.lineHeightHeader2
    }, _popperTitle[theme.breakpoints.up('sm')] = {
      fontSize: _tokens.fontSizeHeader2,
      lineHeight: _tokens.lineHeightHeader2Small
    }, _popperTitle)
  };
};

/**
 * Use `Popper` on top of content to give additional context or information.
 * @done true
 * @updated v7.7.0
 * @versionAdded v2.3.0
 * @examples
 *  MinimalPopper
 *  CustomContent
 *  CloseOnClickaway
 *  ScrollPlayground
 *  MinimalPopperMobileVariant
 */

var Popper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var arrow = props.arrow,
    children = props.children,
    classes = props.classes,
    edsContext = props.edsContext,
    classNameProp = props.className,
    modifiersProp = props.modifiers,
    PaperPropsProp = props.PaperProps,
    text = props.text,
    title = props.title,
    TextTypographyProps = props.TextTypographyProps,
    TitleTypographyProps = props.TitleTypographyProps,
    onClickAway = props.onClickAway,
    ClickAwayListenerProps = props.ClickAwayListenerProps,
    transitionProps = props.transitionProps,
    DrawerProps = props.DrawerProps,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _useState = (0, _react.useState)(null),
    arrowRef = _useState[0],
    setArrowRef = _useState[1];
  var PaperProps = (0, _extends2.default)({}, PaperPropsProp);
  if (!PaperProps['aria-live']) {
    PaperProps['aria-live'] = 'assertive';
  }
  var modifiers = [{
    name: 'arrow',
    enabled: !(0, _isNil.default)(arrow),
    options: {
      element: arrowRef
    }
  }, {
    name: 'flip',
    enabled: true
  }, {
    name: 'offset',
    options: {
      offset: [0, 16]
    }
  }].concat(modifiersProp);
  var className = (0, _classnames.default)(classes.popper, classNameProp);

  // Build Popper content
  var PopperContent = /*#__PURE__*/_react.default.createElement("div", {
    dir: edsContext.dir
  }, arrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "hedtech-popper-arrow",
    ref: setArrowRef
  }), /*#__PURE__*/_react.default.createElement(_Paper.default, (0, _extends2.default)({
    elevation: 0,
    classes: {
      root: classes.paperRoot
    }
  }, PaperProps, {
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    classes: {
      root: classes.popperTitle
    },
    gutterBottom: true
  }, TitleTypographyProps), title), text && /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    gutterBottom: true,
    className: (0, _classnames.default)((_classNames = {}, _classNames[classes.popperText] = children !== undefined, _classNames))
  }, TextTypographyProps), text), children));
  var Content = onClickAway ? /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, (0, _extends2.default)({
    onClickAway: onClickAway,
    touchEvent: false
  }, ClickAwayListenerProps), PopperContent) : PopperContent;

  // NOTE: Structure must be, Popper > Transition > ClickAway > Content
  // MUI v5 scrollTop of null error: https://mui.com/material-ui/migration/troubleshooting/#cannot-read-property-scrolltop-of-null
  // needed to wrap content with div, when we render with a transition
  return rest.transition ? /*#__PURE__*/_react.default.createElement(_Popper.default, (0, _extends2.default)({
    className: className,
    modifiers: modifiers
  }, rest), function (_ref) {
    var TransitionProps = _ref.TransitionProps;
    return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({}, TransitionProps, transitionProps), /*#__PURE__*/_react.default.createElement("div", null, Content));
  }) : /*#__PURE__*/_react.default.createElement(_Popper.default, (0, _extends2.default)({
    className: className,
    modifiers: modifiers
  }, rest), Content);
});
Popper.muiName = 'Popper';
Popper.displayName = 'Popper';
Popper.propTypes = {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the `Popper`
   * instance.
   *
   * **Note: Only applies to the web version of this component.**
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
  /**
   * If `true`, popper will display the arrow.
   *
   * **Note: Only applies to the web version of this component.**
   */
  arrow: _propTypes.default.bool,
  /**
   * `Popper` render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * @ignore
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the `anchorEl`'s top-level document object,
   * so it's simply `document.body` most of the time.
   *
   * **Note: Only applies to the web version of this component.**
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
  /**
   * Disable the portal behavior.
   * The children stay within its parent DOM hierarchy.
   *
   * **Note: Only applies to the web version of this component.**
   */
  disablePortal: _propTypes.default.bool,
  /**
   * Always keep the children in the DOM.
   *
   * **Note: Only applies to the web version of this component.**
   */
  keepMounted: _propTypes.default.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the `Popper`.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   *
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   *
   * **Note: Only applies to the web version of this component.**
   */
  modifiers: _propTypes.default.array,
  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,
  /**
   * Props provided to the `Paper` component
   */
  PaperProps: _propTypes.default.object,
  /**
   * Props provided to the text `Typography` component
   */
  TextTypographyProps: _propTypes.default.object,
  /**
   * Props provided to the title `Typography` component
   */
  TitleTypographyProps: _propTypes.default.object,
  /**
   * `Popper` placement.
   *
   * **Note: Only applies to the web version of this component.**
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   *
   * **Note: Only applies to the web version of this component.**
   */
  popperOptions: _propTypes.default.object,
  /**
   * Paragraph text that will render below the `title` text and above any children.
   */
  text: _propTypes.default.string,
  /**
   * Paragraph text that renders above the `text` paragraph text.
   */
  title: _propTypes.default.string,
  /**
   * Help supporting a react-transition-group/Transition component.
   *
   * **Note: Only applies to the web version of this component.**
   */
  transition: _propTypes.default.bool,
  /**
   * Properties applied to the Transition component.
   *
   * **Note: Only applies to the web version of this component.**
   */
  transitionProps: _propTypes.default.object,
  // /**
  //  * The component used for the transition.
  //  */
  // TransitionComponent: PropTypes.oneOf([
  //     'Collapse', 'Fade', 'Grow', 'Slide', 'Zoom'
  // ]),

  /**
   * Function to perform when clicked outside of the `Popper`.
   *
   * **Note: This applies to the web and mobile version of this component.**
   *
   * The web version invokes this function via a `ClickAwayListener` component, while the mobile
   * version invokes this function via a `Drawer` component.
   */
  onClickAway: _propTypes.default.func,
  /**
   * Props provided to the `ClickAwayListener` component.
   *
   * **Note: Only applies to the web version of this component.**
   */
  ClickAwayListenerProps: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Fires when the mobile version of the Popper closes.
   *
   * **Note: Only applies to the mobile version of this component. This will be fired at the same
   * time as `onClickAway`.**
   */
  onClose: _propTypes.default.func
};
Popper.defaultProps = {
  placement: 'bottom',
  transition: true,
  modifiers: []
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.withStyles)(styles)(Popper));